import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

const rootElement = document.getElementById("cotizador_root");
const legalUrl = document.getElementById("legal_url");
const modelUrl = document.getElementById("model_url");
const ufValue = rootElement ? parseFloat(rootElement.dataset.uf) : null;


if (legalUrl && modelUrl) {
    const legal_url = legalUrl.dataset.legalurl;
    const model_url = modelUrl.dataset.modelurl;
    const car_id = rootElement.dataset.car ? parseInt(rootElement.dataset.car) : null;
    ReactDOM.render(
        <App
            legal_url={legal_url}
            model_url={model_url}
            car_id={car_id}
            uf_value={ufValue}
        />,
        rootElement
    );
}